import { ContactInputType } from '../../types/common/ContactType';

import { ErrorMessages } from '../../types/common/Messages';

const requiredInputValidation = (
    input: ContactInputType,
    setInquireErrorMessage: (value: string) => void,
    setTextErrorMessage: (value: string) => void
) => {
    // error stateの初期化
    setInquireErrorMessage('');
    setTextErrorMessage('');
    const showModalMessage: Array<string> = [];
    // 入力内容が512文字以内であるか否か　お問い合わせ詳細・備考
    if (!(input.contactText.length <= 512)) {
        setTextErrorMessage(ErrorMessages.CONTACT_VAL01);
        showModalMessage.push(ErrorMessages.CONTACT_VAL01);
    }
    // 必須入力チェック お問い合わせ種別
    if (input.checkedInquire.length === 0) {
        setInquireErrorMessage(ErrorMessages.CONTACT_VAL02);
        if (!showModalMessage.includes(ErrorMessages.CONTACT_VAL02_MODAL)) {
            showModalMessage.push(ErrorMessages.CONTACT_VAL02_MODAL);
        }
    }
    // 必須入力チェック お問い合わせ詳細・備考
    if (input.contactText.length === 0) {
        setTextErrorMessage(ErrorMessages.CONTACT_VAL02);
        if (!showModalMessage.includes(ErrorMessages.CONTACT_VAL02_MODAL)) {
            showModalMessage.push(ErrorMessages.CONTACT_VAL02_MODAL);
        }
    }

    return showModalMessage;
};

export const ContactLogic = {
    requiredInputValidation,
};
